<template>
    <div class="offer-box">
        <!-- <img v-if="offerLogo" :src="offerLogo" class="offer-box__flag" :class="[offerPaused?'gray-filter':'']"> -->

        <vx-card :class="vxCardClassNames" v-if="(typeof offer.meta !== 'undefined')">
            <div class="offer-box__heading text-center mb-2">
                <router-link :to="{name:'offerInfo', params: { offerId: offer.offer_id }}">
                    <div class="offer-box__card__image flex items-center justify-center mx-auto">
                        <img 
                            :src="offer.meta.avatar" :alt="offer.full_name" class="responsive card-offer-img"
                            :class="deactiveClass">
                    </div>
                </router-link>
            </div>

            <div class="card-offer-info text-left flex flex-col justify-center mb-3" :style="[(screen === screenName) ? {'height':'auto'} : {}]" :class="[offerPaused?'text-gray':'']">
                <!-- Hoa hồng -->
                <p class="mb-3 text-md font-medium flex items-center">
                    <feather-icon 
                        class="mr-3 w-6 h-6 fill-current text-primary"
                        :class="deactiveClass"
                        icon="DollarSignIcon" />
                    <span class="text-gray text-md font-normal">
                        {{ offer.meta['commission_rate_lite'] || $t("global.noMatch") }}
                    </span>
                </p>

                <!-- MOP -->
                <p class="mb-3 text-md font-medium flex items-center">
                    <feather-icon 
                        class="mr-3 w-6 h-6 fill-current text-primary"
                        :class="deactiveClass"
                        icon="StarIcon" />
                    <span class="text-gray text-md font-normal">
                        {{ offer.meta['loyalty_rate_lite'] || "0" }} HPoint
                    </span>
                </p>

                <!-- Danh mục -->
                <p class="w-1/2 md:w-full mb-3 text-md font-medium flex items-start md:items-center">
                    <feather-icon 
                        class="mr-2 md:mr-3 w-6 h-6 fill-current text-primary"
                        :class="deactiveClass"
                        icon="GridIcon" />
                    <span class="text-gray text-md font-normal">
                        {{ categories || $t("global.noMatch") }}
                    </span>
                </p>

                <!-- CVR -->
                <p class="w-1/2 md:w-full mb-3 text-md font-medium flex items-start md:items-center">
                    <feather-icon 
                        class="mr-2 md:mr-3 w-6 h-6 fill-current text-primary" 
                        :class="deactiveClass"
                        icon="BarChart2Icon" />
                    <span class="text-gray text-md font-normal">
                        CVR: {{offer.meta['cvr_text'] ? offer.meta['cvr_text'] + "%" : "0%"}}
                    </span>
                </p>

                <!-- EPC -->
                <p class="mb-3 text-md font-medium flex items-center">
                    <feather-icon 
                        class="mr-3 w-6 h-6 fill-current text-primary"
                        :class="deactiveClass"
                        icon="DollarSignIcon" />
                    <span class="text-gray text-md font-normal">
                        EPC: {{offer.meta['epc_text'] ? offer.meta['epc_text'] + "đ" : "0đ"}}
                    </span>
                </p>

                <!-- Update -->
                <p class="text-md font-medium flex items-center">
                    <feather-icon 
                        class="mr-3 w-6 h-6 fill-current text-primary" 
                        :class="deactiveClass"
                        icon="RotateCwIcon" />
                    <span class="text-gray text-md font-normal">
                        {{$t('offer.updatedAt')}}: {{updatedAt}}
                    </span>
                </p>
            </div>
            <div v-bind="passingPropsToAction" v-if="showBtn" class="flex justify-between flex-wrap card-offer-btn mt-auto">                
                <!-- Create link offer -->
                <!-- Condition is_locked to fix the error allowed two 
                    or greater refcode publisher exist in multiple type running campaign -->
                    <!-- Paused -->
                <Button class="w-full" v-if="offer.is_paused" type="filled" color="grey" @click="onAction('paused')">
                    {{ $t('offer.paused') }}
                </Button>

                <!-- Locked -->
                <Button class="w-full" v-else-if="offer.is_locked" type="outlined" color="danger" @click="onAction('locked')">
                    {{ $t('offer.locked') }}
                </Button>

                 <!-- Pending -->
                <Button class="w-full" v-else-if="offer.is_pending" type="outlined" color="warning" @click="onAction('pending')">
                    {{ $t('offer.pending') }}
                </Button>

                <!-- Running -->
                <Button class="w-full offer-card-create-link" v-else-if="offer.is_running" :to="routeInfo" type="outlined" color="blue" @click="onAction('createLink')">
                    {{ $t('offer.makeLink') }}
                </Button>

                <!-- Sign up Offer -->
                <Button class="w-full" v-else-if="offer.is_unregister" @click="openPopup()" type="outlined" color="hyperlead" :class="screen === screenName ? 'offer-info-register' : 'offer-card-register'">
                    {{ $t('offer.register') }}
                </Button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import Button from '../../components/Button/Button.vue'
    import FeatherIcon from '../../components/FeatherIcon.vue';
    import moment from 'moment'
    import VxCard from '../../components/vx-card/VxCard.vue';

    export default {
        name: "OfferBox",
        
        components: {
            Button,
            FeatherIcon,
            VxCard
        },
        
        props: {
            offer:{
                type: Object,
                require: true
            },
            offerFlags:{
                type: Array,
                require: true
            },
            screen:{
                type: String,
                require: false
            },
            indexCache:{
                type: Number,
                require: false
            },
            shadow: {
                type: Boolean,
                default: true
            },

            passingPropsToAction: {
                type: [Array, String, Number, Boolean, Object],
                default: null,
            }
        },

        computed: {

        	offerLogo() {
				let flag = this.offerFlags.filter(item => {
                    // Check attributes has exist in object before checking value
                    if(!this.offer.hasOwnProperty("meta") || !this.offer.meta.hasOwnProperty("flags")) return false;
                    
                    return item.code === this.offer.meta.flags;
                })[0];
				if(typeof flag != 'undefined') {
					return flag.image;
                }
        		return '';
            },

            auth() {
                return this.$auth.user();
            },

            // Computed classNames
            vxCardClassNames() {
                return {
                    "offer-box__card": true,
                    "shadow-none": this.shadow === false,
                }
            },
            
            /**
             * Response to date latest updated of offer
             */
            updatedAt() {
                return this.offer.updated_at ? moment(this.offer.updated_at, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY") : "";
            },

            /** It mean the class should is de-active (grayscale)  */
            deactiveClass() {
                return {
                    'gray-filter': this.offer.is_paused || this.offer.is_locked,
                }
            }
        },

        watch: {
            /**
             * Parent can be change data in offer,
             * So, we need to watching offer properties to update view on "OfferBox" component
             */
            offer() {
                this.offer = this.offer;
                this.$forceUpdate();
            }
        },

        data(){
            return {
                screenName: 'info',
                btnLabel: 'Không xác định',
                btnIcon: '',
                disabledBtn: false,
                routeInfo: {name:'offerInfo', params: { offerId: this.offer.offer_id }},
                showBtn: true,
                categories: '',
                cacheActiveOfferKey: 'mo-cpl-active-offers',
                offerPaused: false,
                
                isButton: "",
            }
        },
        methods: {
            /**
             * The method to defined render button for offer
             */
            renderBtn(){
                if(this.screen === this.screenName && this.offer.status_text === "running"){
                    this.showBtn = false;
                }
            },

            onAction(action = null) {
                if(!action) return;

                this.$emit(action);
            },

            openPopup() {
                this.$emit("onSignup", {
                    offer: this.offer,
                });

                this.onAction('register');
            },
        },
        
        filters: {
            empty: function(val){
                if (typeof val === 'undefined' || !val) return '';
                return val;
            }
        },

        created() {
            if(this.offer.hasOwnProperty("meta") && this.offer.meta.hasOwnProperty('categories') && this.offer.meta['categories']){
                this.categories = this.offer.meta['categories'][0];
                if(this.offer.meta['categories'].length >= 2){
                    this.categories +=  ', ' + this.offer.meta['categories'][1]
                }
            }
        },
        
        mounted() {
            this.renderBtn();
        },
    }
</script>

<style lang="scss">
.offer-box {
    position: relative;
    height: 100%;

    &__flag {
        position: absolute;
        z-index: 1;
        right: 1rem;
        top: 1rem;
        height: 40px;
        width: 40px;
    }

    .offer-box__card {
        border-radius: 6px;
        height: 100%;

        .offer-box__heading {
            .offer-box__card__image{
                height: 48px;
                width: 156px;
                // background: rgba($color: #82868B , $alpha: 0.1);
                // border-bottom: 1px solid rgba($color: #82868B, $alpha: 0.5);

                .card-offer-img{
                    height: 100%;
                    width: 100%;
                    max-width: 100%;
                    display: unset !important;
                    object-fit: contain;
                }
            }
        }

        .vx-card__collapsible-content {
            height: 100%;

            .vx-card__body {
                display: flex;
                flex-direction: column;
                padding: 20px;
                height: 100%;
            }
        }
    }

    .gray-filter {
        color: var(--vs-hex-gray) !important;
    }

    .card-offer-info{
        padding: 16px (40px - 16px) 10px;
        p {
            font-size: 14px;
            &:first-child{
                font-size: 1rem;
                font-weight: 500;
            }
        }
    }
    .card-offer-info-p {
        font-size: 12px;
    }
    .card-offer-btn button {
        padding: 9px !important;
    }
    .input-label{
        font-weight: 600;
        font-size: .85rem;
        color: rgba(0,0,0,.7);
    }
}

@media screen and (max-width: 570px) {
    .offer-box {
    .offer-box__card {
        .offer-box__heading {
            .offer-box__card__image{
                width: 100%;
                
                .card-offer-img{
                }
            }
        }

        .vx-card__collapsible-content {

            .vx-card__body {
            
            }
        }
    }

    .card-offer-info{
        padding: 0;
        p {
            &:first-child{
            }
        }
    }
}
}
</style>



// WEBPACK FOOTER //
// src/views/offer/OfferBox.vue